import { type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * Skeleton — shimmer placeholder for loading states (DESIGN-SYSTEM §5).
 * Uses Tailwind's `animate-pulse` (auto-disabled under prefers-reduced-motion
 * via the global rule in index.css). Size it with width/height utility classes.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-md bg-bg-elevated/60", className)}
      {...props}
    />
  );
}
Skeleton.displayName = "Skeleton";
